import { Context } from '@vue-storefront/core';
import { GoodDetails, GoodList, GoodListsParams, SkuDetails, ApiResult, SkuProps, SkuPropValues } from '../../types';
import Cache from '../cache/cache';

export default async function getProduct(context: Context, params: GoodListsParams): Promise<ApiResult> {
  const cacheKey = 'getProduct_' + JSON.stringify(params);
  const cacheData = Cache.getCache(context, cacheKey);
  if (cacheData) {
    return cacheData;
  }

  const url = new URL('/mall/good/list', context.config.api.url);
  const { limit, catId, page, sort, subCatId, q } = params;
  const { data: res } = await context.client.post(url.href, { limit, cat_id: catId, page, sort, sub_cat_id: subCatId, q });
  if (res.code === 0) {
    const result = res.data;
    const goodList: GoodList = {
      list: [],
      total: result.total_count,
      page: result.page,
      limit: result.limit
    };
    if (result && result.list) {
      // 循环list
      result.list.forEach((x) => {
        const goodData: GoodDetails = {
          goodId: x.good_id,
          shopID: x.shop_id,
          viewID: x.view_id,
          catId: x.cat_id,
          title: x.title,
          priceMin: x.price_min,
          priceMax: x.price_max,
          desc: '',
          note: x.note,
          videoUrl: x.video_url,
          imageUrl: x.image_url,
          imageUrl1: x.image_url_1,
          imageUrl2: '',
          imageUrl3: '',
          imageUrl4: '',
          isInWishlist: x.is_in_wish_list,
          rate: x.rate,
          createTime: x.create_time,
          updateTime: x.update_time,
          slug: x.slug,
          skus: [],
          skuProps: [],
          goodInfos: x.good_infos,
          subTitle: x.sub_title,
          cId: x.cid,
          relateGoods: x.relate_goods,
          imageUrl5: '',
          imageUrl6: '',
          imageUrl7: '',
          imageUrl8: '',
          imageUrl9: '',
          discountRatio: x.discount_ratio,
          discountPriceMin: x.discount_price_min,
          discountPriceMax: x.discount_price_max
        };
        if (x.skus) {
          x.skus.forEach((y) => {
            const skuData: SkuDetails = {
              skuId: y.sku_id,
              shopId: y.shop_id,
              goodId: y.good_id,
              propsIds: y.props_ids,
              price: y.price,
              stockNum: y.stock_num,
              outId: y.out_id,
              barcode: y.barcode,
              taxRate: y.tax_rate,
              skuImage: y.sku_image,
              viewId: y.view_id,
              originalPrice: y.original_price
            };
            goodData.skus.push(skuData);
          });
        }
        if (x.sku_props) {
          x.sku_props.forEach((z) => {
            const skuProps: SkuProps = {
              propId: z.prop_id,
              propName: z.prop_name,
              imgUrl: z.img_url,
              viewId: z.view_id,
              values: []
            };
            if (z.values) {
              z.values.forEach((v) => {
                const skuPropValues: SkuPropValues = {
                  valueId: v.value_id,
                  propValue: v.prop_value,
                  viewId: v.view_id,
                  imgUrl: v.image_url
                };
                skuProps.values.push(skuPropValues);
              });
            }
            goodData.skuProps.push(skuProps);
          });
        }
        goodList.list.push(goodData);
      });
    }
    res.data = goodList;
  }
  Cache.setCache(context, cacheKey, res);
  return res;
}
